import React from "react";
import { CircleDollarSign } from "lucide-react";

import { JOB_APPLICATION_MATCH_STATUS, USER_LIST_VIEWS } from "lookup";

import { DropdownMenuItem } from "components/ui/dropdown-menu";
import { tabSupportsTableView } from "components/UserCardList/helpers/userCard";
import { CTA_TITLES } from "components/UserCardList/constants/ctaTitles";
import { cn } from "utils";

const EXCLUDED_RATE_BUTTON_STATUSES = [
  JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMEMBER,
  JOB_APPLICATION_MATCH_STATUS.SKIPPED,
  JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMATCHER,
];

const DEFAULT_BUTTON_CLASS_NAME =
  "transition-all whitespace-nowrap text-sm font-bold py-2 px-3 rounded-lg inline-flex items-center";

const CustomerRateButton = ({
  match,
  disabled,
  setSettingRate,
  viewType,
  activeTabName,
}) => {
  const activeTabSupportsTableView = tabSupportsTableView(activeTabName);

  const openRateModal = () => {
    // Same as ModalProvider: blur menu focus before dialog mounts.
    const active = document.activeElement;
    if (active instanceof HTMLElement && !active.closest('[role="dialog"]')) {
      active.blur();
    }
    setSettingRate(true);
  };

  if (EXCLUDED_RATE_BUTTON_STATUSES.includes(match?.status)) return null;

  if (viewType === USER_LIST_VIEWS.LIST && activeTabSupportsTableView) {
    return (
      <DropdownMenuItem
        onSelect={openRateModal}
        disabled={disabled}
        title={CTA_TITLES.setRate}
      >
        <div className="grid place-items-center h-5 w-5">
          <CircleDollarSign className="h-5 w-5" />
        </div>
        Customer rate
      </DropdownMenuItem>
    );
  }

  return (
    <button
      className={cn(
        DEFAULT_BUTTON_CLASS_NAME,
        "text-gray-600 hover:!fill-sky-500 hover:text-sky-500"
      )}
      onClick={openRateModal}
      disabled={disabled}
      title={CTA_TITLES.setRate}
    >
      <CircleDollarSign className="h-5 w-5" />

      <span className="ml-2">Customer rate</span>
    </button>
  );
};

export default CustomerRateButton;
